import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowUpRight, Mail } from 'lucide-react'
import { Logo } from '@/components/generals/logo'
import { LEGAL_LINKS, NAV_ITEMS, siteConfig } from '@/constants/site'

const PRODUCT_LINKS = [
    ...NAV_ITEMS.filter((item) => item.href !== '/#contacto'),
    { label: 'Descargar la app', href: '/#descargar' }
]

const linkClassName = 'rounded-sm text-muted-foreground transition-colors hover:text-brand-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-400'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-border bg-white'>
            <div className='mx-auto max-w-7xl px-5 pt-16 pb-10 sm:px-8'>
                <div className='grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr]'>
                    <div className='sm:col-span-2 lg:col-span-1'>
                        <Link
                            href='/'
                            aria-label='Jeme, ir al inicio'
                            className='inline-flex rounded-full focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-brand-300'
                        >
                            <Logo />
                        </Link>

                        <p className='mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground'>
                            La app que conecta talleres, desguaces y particulares para encontrar y comprar piezas de coche.
                        </p>
                    </div>

                    <nav aria-label='Producto'>
                        <h2 className='text-sm font-bold text-foreground'>
                            Producto
                        </h2>

                        <ul className='mt-4 space-y-3 text-sm'>
                            {PRODUCT_LINKS.map((item) => (
                                <li key={item.href}>
                                    <Link href={item.href} className={linkClassName}>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div>
                        <h2 className='text-sm font-bold text-foreground'>
                            Contacto
                        </h2>

                        <ul className='mt-4 space-y-3 text-sm'>
                            <li>
                                <a href={`mailto:${siteConfig.contact.email}`} className={`${linkClassName} inline-flex items-center gap-2`}>
                                    <Mail className='size-4 shrink-0' aria-hidden='true' />
                                    {siteConfig.contact.email}
                                </a>
                            </li>

                            <li>
                                <Link href='/#contacto' className={`${linkClassName} inline-flex items-center gap-1.5`}>
                                    Formulario de contacto
                                    <ArrowUpRight className='size-4' aria-hidden='true' />
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <nav aria-label='Legal'>
                        <h2 className='text-sm font-bold text-foreground'>
                            Legal
                        </h2>

                        <ul className='mt-4 space-y-3 text-sm'>
                            {LEGAL_LINKS.map((item) => (
                                <li key={item.href}>
                                    <Link href={item.href} className={linkClassName}>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>

                <div className='mt-14 flex flex-col gap-3 border-t border-border pt-8 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        © <span suppressHydrationWarning>{new Date().getFullYear()}</span> Jeme. Todos los derechos reservados.
                    </p>

                    <p>
                        Recambios para talleres, desguaces y particulares.
                    </p>
                </div>
            </div>
        </footer>
    )
}
